import { createContext, useContext } from "react";
import type { AdminUser } from "@/modules/auth/api/authApi";

export type AdminSession = {
  user: AdminUser | null;
  loading: boolean;
  error: Error | null;
  login: (email: string, password: string, remember: boolean) => Promise<AdminUser>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
  can: (permission: string) => boolean;
};

export const SessionContext = createContext<AdminSession | null>(null);

export function useAdminSession() {
  const session = useContext(SessionContext);
  if (!session) throw new Error("useAdminSession must be used inside AdminSessionProvider.");
  return session;
}
